import React from "react"
import { Box } from "@carrotfertility/carotene-core"

interface NoResultLayoutProps {
  header: React.ReactNode
  body: React.ReactNode
  actions: React.ReactNode
  footer?: React.ReactNode
}

export function NoResultLayout({ header, body, actions, footer }: NoResultLayoutProps): JSX.Element {
  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="22.6875rem"
        gap={(theme) => theme.tokens.spacing.md}
      >
        <Box
          component="img"
          src={"/images/search.png"}
          srcSet={"/images/search-2x.png"}
          alt=""
          sx={{ inlineSize: "4.25rem", blockSize: "4.25rem" }}
        />
        <Box textAlign="center" gap={(theme) => theme.tokens.spacing.xs}>
          {header}
          {body}
        </Box>
        {actions}
        {footer}
      </Box>
    </Box>
  )
}
